import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/tools/admin')({
	staticData: {
		authorize: (ability) => ability.can('manage', 'devTools'),
	},
	head: () => ({ meta: [{ title: 'Admin • Cadstrom' }] }),
});
